export default __webpack_public_path__ + "static/media/lunch.4ecc4fb4.png";